import { api } from './client';

export type ControleBucket = 'concept' | 'beschikbaar' | 'wachtend';

export interface MateriaallijstControleRow {
  pickingId: number;
  pickingName: string | null;
  bucket: ControleBucket;
  stateLabel: string;
  state: string;
  /** Site / werf name. */
  werf: string;
  /** Uploaded list name. */
  lijst: string | null;
  projectId: number | null;
  createdAt: string | null;
  ageDays: number | null;
  isEasykit: boolean;
}

export interface MateriaallijstControleData {
  total: number;
  counts: Record<ControleBucket, number>;
  rows: MateriaallijstControleRow[];
}

export async function fetchMateriaallijstenNietGereed(): Promise<MateriaallijstControleData> {
  return api<MateriaallijstControleData>('/api/admin/controle/materiaallijsten');
}

// ─── OA rolling-PO settlement audit ─────────────────────────────────────────

export type OaFindingType =
  | 'tier_mismatch'
  | 'collector_geleverd'
  | 'no_supplierinfo'
  | 'missing_price'
  | 'btw_mismatch'
  | 'basis_unknown'
  | 'multi_installateur'
  | 'installateur_mismatch';

/** 'definitief' = the fase is fully approved, the number cannot move — safe to act on. */
export type OaReadiness = 'definitief' | 'voorlopig';

export type OaSeverity = 'error' | 'warning' | 'info';

export interface OaAuditFinding {
  type: OaFindingType;
  severity: OaSeverity;
  readiness: OaReadiness;
  poId: number;
  poName: string;
  vendorId: number;
  vendorName: string;
  lineId: number | null;
  lineName: string;
  collectorId: number | null;
  collectorName: string | null;
  projectId: number | null;
  projectName: string | null;
  faseId: number | null;
  faseName: string | null;
  message: string;
  /** Billed − expected, × m². Positive = overpaying. */
  deltaEur: number | null;
  detail: {
    m2?: number;
    basisM2?: number;
    billedRate?: number;
    expectedRate?: number;
    taxNames?: string[];
  };
}

export interface OaAuditPo {
  poId: number;
  poName: string;
  vendorId: number;
  vendorName: string;
  amountUntaxed: number;
  deltaEur: number;
  findingCount: number;
  definitiefCount: number;
}

export interface OaPoAuditData {
  pos: OaAuditPo[];
  findings: OaAuditFinding[];
  counts: Record<OaFindingType, number>;
  /** Gross, never netted: over- and underpayments both occur and must not cancel out. */
  totalOverEur: number;
  totalUnderEur: number;
  btwCheckSkipped: boolean;
}

export async function fetchOaPoAudit(): Promise<OaPoAuditData> {
  return api<OaPoAuditData>('/api/admin/controle/oa-pos');
}
